import React from 'react';

import classnames from 'classnames';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalRequireName = ({
  handleChange,
  requireName,
}) => {
  const intl = useIntl();

  return (
    <div className="share-select-require-name share-setting">
      <Label for="inpSelectRequireName" className={classnames('switch', { disabled: !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Require name' })}
          <HelpIcon id="share-require-name">
            {intl.formatMessage({ defaultMessage: 'Require recipients to enter a name before accessing this share link.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-require-name" simple={true} />
          {userHasFeature('share-require-name') && (
          <div className="switch-control input-inner">
            <Input
              type="checkbox"
              name="select-require-name"
              id="inpSelectRequireName"
              value={true}
              checked={requireName}
              onChange={handleChange}
              disabled={!canUserManageShare()}
            />
            <i />
          </div>
          )}
        </div>
      </Label>
    </div>
  );
};

ShareModalRequireName.propTypes = {
  requireName: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalRequireName;
